module.exports = __webpack_public_path__ + "img/logo-ALC-logo-tmp.fa2af152.svg";